// Created by jarongallo at 6/9/21
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { UI_LABELED_INPUT_NOTES_TYPE, UI_LABELED_INPUT_TEXT_FIELD } from '../../../../../components/UI/UILabeledInput/config';
import { USER_ROLE_EDITOR } from '../../../../../utils/Config/Constants';
import { getSignedInUserRoleSelector } from '../../../../../redux/selectors/CurrentUserSelectors';
import UILabeledInput from '../../../../../components/UI/UILabeledInput';
import UICard from '../../../../../components/UI/UICard/UICard';
import Queries from '../../../../../utils/API/Queries';
import UIListInputRow from '../../../../../components/UI/UIListInputRow';
import UIModal from '../../../../../components/UI/UIModal';
import UIOverlayCard from '../../../../../components/UI/UIOverlayCard';
import UIIconButton from '../../../../../components/UI/UIIconButton';
import { EditIcon } from '../../../../../assets/icons';
import { toast } from 'react-toastify';
import { GET_SERVICE_REQUEST_NOTES } from './queries';
import * as strings from './strings';
import { UI_ICON_BUTTON_OUTLINE_TYPE } from '../../../../../components/UI/UIIconButton/config';

export default function ServiceRequestNotesTab({ serviceRequestId }: ServiceRequestNotesTabProps) {
	const userRole = useSelector(getSignedInUserRoleSelector);
	const [serviceRequestNotes, setServiceRequestNotes] = useState<string>('');
	const [editServiceRequestNotes, setEditServiceRequestNotes] = useState<boolean>(false);
	const [isSavingServiceRequestNotes, setIsSavingServiceRequestNotes] = useState<boolean>(false);

	const [updateServiceRequestCall] = useMutation(Queries.UPDATE_SERVICE_REQUEST);

	const [getServiceRequests, { data: serviceRequestData }] = useLazyQuery(GET_SERVICE_REQUEST_NOTES, {
		variables: { id: serviceRequestId }
	});

	// Mark: Lifecycle functions

	useEffect(() => {
		(async () => {
			await getServiceRequests();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (serviceRequestData) {
				setServiceRequestNotes(serviceRequestData.serviceRequest.notes);
			}
		})();
	}, [serviceRequestData]);

	const updateServiceRequestNotes = async () => {
		setEditServiceRequestNotes(true);
		setIsSavingServiceRequestNotes(true);
		let variables = { id: serviceRequestId, notes: serviceRequestNotes };
		const response = await updateServiceRequestCall({ variables });
		const { updateServiceRequest } = response['data'];
		if (updateServiceRequest) {
			setEditServiceRequestNotes(false);
			setIsSavingServiceRequestNotes(false);
			toast.success(strings.setNotes);
			await getServiceRequests();
		}
	};

	const renderEditNotesModal = () => {
		const hideModal = () => setEditServiceRequestNotes(false);
		return (
			<UIModal condition={editServiceRequestNotes}>
				<UIOverlayCard hideModal={hideModal} title={strings.editNotesTitle}>
					<UIListInputRow
						type={UI_LABELED_INPUT_TEXT_FIELD}
						onChangeValue={(serviceRequestNotes) => setServiceRequestNotes(serviceRequestNotes)}
						value={serviceRequestNotes}
						placeholder={strings.editNotesPlaceholder}
					/>
					<div className='general-buttons-container'>
						<UIIconButton dark isLoading={isSavingServiceRequestNotes} onClick={() => updateServiceRequestNotes()} text={strings.saveNotesButton} />
					</div>
				</UIOverlayCard>
			</UIModal>
		);
	};
	return (
		<div className='uiServiceRequest__top'>
			<div className='uiServiceRequest__header'>
				<div className='uiServiceRequest__header--cards'>
					<UICard title={strings.requestNotesTitle}>
						<UILabeledInput
							hideLabel
							containerStyle={{ margin: '0 0 16px 0' }}
							onChangeValue={(serviceRequestNotes) => setServiceRequestNotes(serviceRequestNotes)}
							value={serviceRequestNotes}
							type={UI_LABELED_INPUT_NOTES_TYPE}
						/>
						{userRole !== USER_ROLE_EDITOR ? (
							<UIIconButton
								type={UI_ICON_BUTTON_OUTLINE_TYPE}
								onClick={() => setEditServiceRequestNotes(true)}
								text={strings.editText}
								icon={EditIcon.white}
							/>
						) : null}
					</UICard>
				</div>
			</div>
			{renderEditNotesModal()}
		</div>
	);
}
